"use client";
import {CSSProperties, JSX, RefObject} from "react";
import {exo2SemiBold, ralewayBold, montserratRegular, exo2Bold} from "@@/utils/fonts";
import useAppearOnScroll from "@@/hooks/useAppearsOnScroll";
import ProgressiveImage from "@@/utils/ProgressiveImage";
import Button from "@@/components/ui/Button";
import LogoStroke from "@@/public/img/shared/logo_stroke.svg"
import Image from "next/image";

interface Props {
    title: string;
    subtitle?: string;
    items: {
        title: string;
        desc: string;
        animation?: {
            ref: RefObject<HTMLLIElement | null>;
            className: string;
            style: CSSProperties;
        }[];
    }[]
    sectionId?: string;
    className?: string;
}

export default function Commitments({ title, items, sectionId, className, subtitle }: Props): JSX.Element {

    const titleAnim = useAppearOnScroll<HTMLHeadingElement>({ from: "fromBottom", duration: 800, delay: 0, offset: 50 });
    const subtitleAnim = useAppearOnScroll<HTMLHeadingElement>({ from: "fromBottom", duration: 800, delay: 0, offset: 50 });


    const animatedBg = useAppearOnScroll<HTMLElement>({from: "fadeIn", duration: 800, delay: 0, offset: 200});

    // On ajoute dynamiquement les animations, sans muter les props
    const animatedItems = Array.isArray(items)
        ? items.map((item, index) => {
            const animation = useAppearOnScroll<HTMLLIElement>({
                from: "fromBottom",
                duration: 800,
                delay: index * 100,
            });
            return { ...item, animation };
        })
        : [];


    return (
        <section id="commitments" className={`${className} w-100 px-11 py-5 text-white position-relative`}>
            <Image src={LogoStroke} alt={`logo mediawind`} className={`position-absolute p-center opacity-10 w-100 h-100 object-cover`} />
            <span ref={animatedBg.ref} className={`${animatedBg.className} blue-bg`} style={animatedBg.style}></span>
            <div className={`d-flex flex-column gap-5 p-5`}>
                <h2
                    ref={titleAnim.ref}
                    className={` ${exo2Bold.className} ${titleAnim.className}`}
                    style={titleAnim.style}
                >
                    {title}
                </h2>
                {subtitle && (
                    <h3 ref={subtitleAnim.ref} className={`${subtitleAnim.className} ${exo2SemiBold.className}`} style={subtitleAnim.style}>{subtitle}</h3>
                )}
                <ul className="d-flex list-none space-between gap-2 flex-wrap">
                    {animatedItems.map((item, index) => (
                        <li
                            key={index}
                            ref={item.animation.ref}
                            className={`min-w-150 mx-width-25percent flex-1 pl-2 border-left-light d-flex flex-column gap-1 ${item.animation.className}`}
                            style={item.animation.style}
                        >
                            <h3 className={`${exo2SemiBold.className}`}>{item.title}</h3>
                            <p className={montserratRegular.className}>{item.desc}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}